<template>
  <div>
    <o-section :overlay="true">
      <o-checkbox name="buitenland">Buitenland (buiten de Benelux)</o-checkbox>
      <o-checkbox name="kinderstoel">Kinderstoel</o-checkbox>
      <o-checkbox name="geenkinderstoel">Geen kinderstoel</o-checkbox>
      <o-checkbox name="kinderstoel2">Kinderstoel (15-36kg)</o-checkbox>
    </o-section>
  </div>
</template>

<script>
import OCheckbox from '@/components/base/OCheckbox.vue'
export default {
  name: 'OEditOptions',
  components: { OCheckbox }
}
</script>
